'use client'

import { TextButton } from '@dfds-pax/ui'

interface Props {
  explainer?: string
  text?: string
  onClicked: () => void
}

const CreateAccountButton: React.FC<Props> = ({ text, explainer, onClicked }) => {
  return (
    <div className="login-w-full login-py-dfds-xs login-flex login-items-baseline login-gap-x-2 login-justify-start">
      <div className="login-dfds-label login-text-dfds-text-dark-primary">{explainer}</div>
      <TextButton onClick={onClicked}>{text}</TextButton>
    </div>
  )
}

export default CreateAccountButton
